import { useCallback } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Button } from '@/components/buttons';
import { useNavigation } from '@/hooks/navigation';
import { ScLoyaltyBenefits } from './styled';

const BENEFITS_STEP = '01';

export const LoyaltyBenefits = () => {
  const { t } = useTranslation(['vip', 'common']);
  const { navigate } = useNavigation();

  const handleBtnClick = useCallback(
    () => navigate('/loyalty', true),
    [navigate]
  );

  return (
    <ScLoyaltyBenefits>
      <div className="step-wrapper">
        <span className="title">
          <Trans
            components={{
              s: <span className="step" />,
            }}
            i18nKey={'steps.loyaltyBenefits.title'}
            t={t}
            values={{ value: BENEFITS_STEP }}
          />
        </span>
        <span className="description">
          {t('steps.loyaltyBenefits.description')}
        </span>
      </div>
      <Button className="cta-btn" onClick={handleBtnClick}>
        {t('common:learnMore')}
      </Button>
    </ScLoyaltyBenefits>
  );
};
